(ns manage.adset-preview-panel.view.notifications
  (:require ["@mui/material/Alert$default" :as Alert]
            ["@mui/material/Button$default" :as Button]
            ["@mui/material/Stack$default" :as Stack]
            [uix.core :as uix :refer [$ defui]]
            [uix.re-frame :refer [use-subscribe]]))

(defui notifications []
  (let [v (use-subscribe [:adset-preview.notifications/notifications])]
    (when (seq v)
      ($ Stack {:direction "column-reverse"
                :spacing 1
                :padding 2
                :position "fixed"
                :bottom 0
                :right 0
                :z-index 9999}
         (for [[id {:keys [type action message] :or {type "info"}}] v]
           ($ Alert {:key id
                     :severity type
                     :action (when action
                               ($ Button {:color "inherit"
                                          :size "small"
                                          :variant "text"
                                          :on-click (:on-click action)}
                                  (:label action)))}
              message))))))
